import { Box, Grid, SxProps, Theme, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useUserPermissions } from 'shared/hooks';
import { ContractRouteParams } from 'shared/types/routing';
import { CustomerInfoWidgetDownloadButton } from './customer-info-widget-download-button';
import { CustomerInfoWidgetDeleteButton } from './customer-info-widget-delete-button';

const infoWidgetContentStyles: SxProps<Theme> = {
  backgroundColor: '#eeeeee',
  padding: '1rem',
};

const infoWidgetValueDisplayStyles: SxProps<Theme> = {
  fontWeight: 'bold',
};

export function CustomerInfoWidget() {
  const { masterCustomer, abgBrand } = useParams<ContractRouteParams>();
  const userPermissions = useUserPermissions();
  const hasCustomerDeletionApprovePermission = userPermissions.includes('abg-retail.customer.approve');

  return (
    <Box>
      <Grid container sx={infoWidgetContentStyles}>
        <Grid container item xs={3}>
          <Grid item xs={12}>
            <Typography variant='body2'>Customer Name</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography sx={infoWidgetValueDisplayStyles} variant='body2'>
              {masterCustomer}
            </Typography>
          </Grid>
        </Grid>
        <Grid container item xs={3}>
          <Grid item xs={12}>
            <Typography variant='body2'>Brand</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography sx={infoWidgetValueDisplayStyles} variant='body2'>
              {abgBrand}
            </Typography>
          </Grid>
        </Grid>
        {hasCustomerDeletionApprovePermission && <CustomerInfoWidgetDeleteButton />}
        <CustomerInfoWidgetDownloadButton />
      </Grid>
    </Box>
  );
}
